import { createContext, useContext } from 'react'
/**
 * @param state
 * @param action
 */
export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_CATALOG_ARTISTS_LIST':
      return {
        ...state,
        catalogArtworksList: action.payload
      }
    case 'SET_IS_LOADING_LIST':
      return {
        ...state,
        isLoadingList: action.payload
      }
    case 'SET_IS_LOADING_MORE_ITEM':
      return {
        ...state,
        isLoadingNewpage: action.payload
      }
    case 'SET_LABELS':
      return {
        ...state,
        labels: action.payload
      }

    case 'SET_CATALOG_GALLERIES_LIST':
      return {
        ...state,
        catalogGalleriesList: action.payload
      }
    case 'SET_IS_LOADING_GALLERIES_LIST':
      return {
        ...state,
        isLoadingGalleriesList: action.payload
      }
    case 'SET_IS_LOADING_MORE_GALLERIES_ITEM':
      return {
        ...state,
        isLoadingGalleriesNewpage: action.payload
      }
    default:
      return { ...state }
  }
}

export const initialState = {
  /**
   * These are the CMS that come from the server side injected into the entry point that is set in _cmsModuleMap
   */
  CMSProps: null,
  isLoadingList: false,
  isLoadingNewpage: false,
  catalogArtworksList: [],
  isLoadingGalleriesList: false,
  isLoadingGalleriesNewpage: false,
  catalogGalleriesList: [],
  labels: null
}

type StateType = {
  catalogArtworksList: Array<ABTypes.Monolith.ArtworkDetail>,
  isLoadingNewpage: boolean,
  isLoadingList: boolean,
  catalogGalleriesList: Array<ABTypes.Monolith.GalleryDetail>,
  isLoadingGalleriesNewpage: boolean,
  isLoadingGalleriesList: boolean,
  CMSProps: {
    [key: string]: string
  }
}

export const StateContext = createContext<{
  state: StateType;
  refs: any;
  dispatch: React.Dispatch<any>;
}>({
  state: {
    catalogArtworksList: [],
    isLoadingNewpage: false,
    isLoadingList: false,
    isLoadingGalleriesList: false,
    isLoadingGalleriesNewpage: false,
    catalogGalleriesList: [],
    CMSProps: {}
  },
  refs: {},
  dispatch: () => null
})

export const useModuleContext = () => useContext(StateContext)
